<template>
  <div>
    <SlimFilterBarSkeletonLoader v-if="isLoading" />
    <div
      v-if="!isLoading"
      ref="filterbar"
      class="filterbar d-flex align-start"
    >
      <div
        class="filters"
        :class="{
          'mr-6': (filterConfig.datepicker && !hideDatePicker)
            || (!hideFilters && filterConfig.subMenuType),
        }"
      >
        <slot name="prefilter" />
        <FilterMenu
          :module-page-loading="filtersLoading || disabledFilters"
          :show-my-jobs="filterConfig.showMyJobs"
          :hide="hideFilters"
          @filters-tracking-event="handleTrackingEvent"
        >
          <template #toggle-filter:extended>
            <slot name="toggle-filter:extended" :is-disabled="filtersLoading || disabledFilters" />
          </template>
        </FilterMenu>
      </div>
      <div class="filters dppl-right">
        <DatePicker
          v-if="filterConfig.datepicker && !hideDatePicker"
          :disabled="filtersLoading || disabledFilters"
          @filters-tracking-event="handleTrackingEvent"
        />
        <div v-if="!isSubmenuSlotEmpty">
          <slot name="submenu" />
        </div>
        <FilterSubMenu
          v-if="!hideFilters && filterConfig.subMenuType"
          :loading="filtersLoading"
          :type="filterConfig.subMenuType"
          :class="[!isSubmenuSlotEmpty ? 'ml-2' : '']"
          @filters-tracking-event="handleTrackingEvent"
        />
      </div>
    </div>
  </div>
</template>
<script>
import DatePicker from '@/components/filter/dateFilters/DatePicker.vue';
import SlimFilterBarSkeletonLoader from '@/components/shared/SkeletonLoaders/SlimFilterBarSkeletonLoader.vue';
import { mapActions, mapState } from 'pinia';
import FilterSubMenu from '@/components/filter/filterMenu/FilterSubMenu.vue';
import { useTracking } from '@/stores/tracking/tracking';
import { useAppLoading } from '@/stores/app/loading';
import FilterMenu from '@/components/filter/filterMenu/FilterMenu.vue';
import { useAppBase } from '@/stores/app/base';
import { useDatePicker } from '@/stores/filters/datePicker';
import { useFilters } from '@/stores/filters/filters';
import { isSlotEmpty } from '@/helpers/slotsChecker';

export default {
  name: 'FilterBar',
  components: {
    DatePicker,
    FilterMenu,
    FilterSubMenu,
    SlimFilterBarSkeletonLoader,
  },
  props: {
    hideFilters: { default: false, type: Boolean },
    isLoading: { default: false, type: Boolean },
  },
  computed: {
    ...mapState(useAppLoading, ['filtersLoading']),
    ...mapState(useAppBase, ['pageDisabledFilters', 'pageHideDatePicker']),
    ...mapState(useFilters, ['tempFilters', 'filterConfig']),
    ...mapState(useDatePicker, ['dateRange']),
    isSubmenuSlotEmpty() {
      if (!this.$slots.submenu) return true;

      return isSlotEmpty(this.$slots.submenu());
    },
    disabledFilters() {
      return this.pageDisabledFilters[this.$route.name] || false;
    },
    hideDatePicker() {
      return this.pageHideDatePicker[this.$route.name] || false;
    },
    range: {
      get() {
        return this.dateRange;
      },
      set(newValue) {
        const { dateRange } = this;
        const isDifferent = dateRange.start !== newValue.start || dateRange.end !== newValue.end;

        if (isDifferent) {
          this.setDateRange(newValue);
        }
      },
    },
  },
  methods: {
    ...mapActions(useDatePicker, ['setDateRange']),
    handleTrackingEvent({ action, args }) {
      useTracking()[action](args);
    },
  },

};
</script>

<style lang="less" scoped>
:deep(.v-toolbar) {
  background: transparent;
}

:deep(.v-toolbar__content) {
  padding: 0 !important;
}

.filterbar {
  padding: 0;
}

.filters {
  display: flex;
  align-items: center;
}
.dppl-right {
  align-self: stretch;
}
</style>
